import { render, staticRenderFns } from "./ReviewBoosterConfigEmpty.vue?vue&type=template&id=503a11a6&scoped=true&"
import script from "./ReviewBoosterConfigEmpty.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterConfigEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ConfigEmpty.scss?vue&type=style&index=0&id=503a11a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a11a6",
  null
  
)

export default component.exports